import React from 'react';
import ReportDataSummary from "../../report/redesigned/ReportDataSummary";
import {getBuyerInvoicesReportUrl} from "../../../requests/reports/invoices/buyer-invoices-requests";
import DownloadCSVButton from "../../report/export/DownloadCSVButton";


const BuyerInvoicesReportDataSummary = (
  {
    accountId,
    query,
    count,
    title,
    setExpandedItems,
    setExpandedAll,
    isShowCollapseButton = false,
    handleExpandAll,
    hasExpandedItems
  }
) => {
  return (
    <ReportDataSummary
      count={count}
      title={title}
      setExpandedItems={setExpandedItems}
      setExpandedAll={setExpandedAll}
      isShowCollapseButton={isShowCollapseButton}
      handleExpandAll={handleExpandAll}
      hasExpandedItems={hasExpandedItems}
    >
      <DownloadCSVButton
        title={'Download Report'}
        reportUrl={getBuyerInvoicesReportUrl(accountId, query)}
      />
    </ReportDataSummary>

  )
}

export default BuyerInvoicesReportDataSummary;
